import { render } from "./DatasetSegmentsList.vue?vue&type=template&id=71ebcddc"
import script from "./DatasetSegmentsList.vue?vue&type=script&lang=js"
export * from "./DatasetSegmentsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__